//常用函数

/* 计算两日期相差的日期年月日等 */
//dateDiff 方法
//返回两个日期对象之间的时间间隔。
//interval ：D表示查询精确到天数的之差
//interval ：H表示查询精确到小时之差
//interval ：M表示查询精确到分钟之差
//interval ：S表示查询精确到秒之差
//interval ：T表示查询精确到毫秒之差
function DateDiff(interval, date1, date2) {
    interval = interval.toUpperCase();

    var objInterval;
    if (interval == 'MM') {
        //用-分成数组
        var d1 = date1.split("-");
        var d2 = date2.split("-");
        //获取年,月数
        var year1 = parseInt(d1[0]),
            month1 = parseInt(d1[1]),
            year2 = parseInt(d2[0]),
            month2 = parseInt(d2[1]),
            //通过年,月差计算月份差
            months = (year2 - year1) * 12 + (month2 - month1) + 1;
        var date = months;
    }
    else {
        if (interval == 'H')
            objInterval = 1000 * 60 * 60;
        else if (interval == 'D')
            objInterval = 1000 * 60 * 60 * 24;
        else if (interval == 'M')
            objInterval = 1000 * 60;
        else if (interval == 'S')
            objInterval = 1000;
        else if (interval == 'T')
            objInterval = 1;
        var dt1 = Date.parse(d1.replace(/-/g, '/'));
        var dt2 = Date.parse(d2.replace(/-/g, '/'));
        try {
            var date = Math.round((dt2 - dt1) / objInterval);
        }
        catch (e) {
            return e.message;
        }

    }
    return date;
}
//格式化日期
function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
        }
    }
    return fmt;
}

function toFixed(value, digitNum) {
    if ((value == undefined || value == null || value == '' || isNaN(value)) && value != 0) {
        return '-';
    }
    if ((digitNum == undefined || digitNum == null || digitNum == '' || isNaN(digitNum)) && value != 0) {
        return value;
    }
    return value.toFixed(digitNum);
}


function getRounding(value, num) {
    let t = 1;
    for (let i = 0; i < num; i++) {
        t = t * 10;
    }
    return Math.round(value * t) / t;
}

function numArrySort(arr) {
    let sortObj = arr.sort(function (a, b) {
        return a - b;
    });
    return sortObj;
}

function getAvgValue(arr) {
    let avg = 0;
    let sum = 0;
    arr.forEach((num, index, l) => {
        sum += num;
    })
    avg = sum / arr.length;
    return avg;
}

//获取四分位数（组）
function getMedianData(obj) {
    let arry = [];
    if (obj.length == 0) {
        return [0, 0, 0, 0, 0];
    }
    let sortObj = obj.sort(function (a, b) {
        return a - b;
    });
    //最小值
    arry.push(sortObj[0]);
    let q1 = 0;
    let q2 = 0;
    let q3 = 0;
    q2 = getMedian(sortObj);
    if (sortObj.length % 2 == 0) {
        if (sortObj.length == 0) {
            q2 = 0;
        } else {
            let newObj1 = sortObj.slice(0, sortObj.length / 2);
            let newObj2 = sortObj.slice(sortObj.length / 2);
            q1 = getMedian(newObj1);
            q3 = getMedian(newObj2);
        }
    } else {
        let newObj1 = sortObj.slice(0, (sortObj.length - 1) / 2);
        let newObj2 = sortObj.slice((sortObj.length + 1) / 2);
        q1 = getMedian(newObj1);
        q3 = getMedian(newObj2);
    }
    arry.push(q1);
    arry.push(q2);
    arry.push(q3);
    //最大值
    arry.push(sortObj[sortObj.length - 1]);
    return arry;
}
//获取中位数
function getMedian(obj) {
    let num = 0;
    let sortObj = obj.sort(function (a, b) {
        return a - b;
    });
    if (sortObj.length % 2 == 1) {
        num = sortObj[(sortObj.length + 1) / 2 - 1];
    } else {
        switch (sortObj.length) {
            case 0:
                num = 0;
                break;
            case 2:
                num = (sortObj[0] + sortObj[1]) / 2;
                break;
            default:
                num =
                    (sortObj[sortObj.length / 2] + sortObj[sortObj.length / 2 - 1]) /
                    2;
                break;
        }
    }
    return num;
}

function DownloadFile(blobData, blobType, fileName) {
    var param = {};
    blobType ? param.type = blobType : {};
    var blob = new Blob([blobData], param);
    // 针对于IE浏览器的处理, 因部分IE浏览器不支持createObjectURL
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
    }
}

function byteLength(str) {  //获取字符串的字节数，扩展string类型方法
    debugger
    var b = 0; var l = str.length;  //初始化字节数递加变量并获取字符串参数的字符个数
    if (l) {  //如果存在字符串，则执行计划
        for (var i = 0; i < l; i++) {  //遍历字符串，枚举每个字符
            if (str.charCodeAt(i) > 255) {  //字符编码大于255，说明是双字节字符
                b += 2;  //则累加2个
            } else {
                b++;  //否则递加一次
            }
        }
        return b;  //返回字节数
    } else {
        return 0;  //如果参数为空，则返回0个
    }
}
function getSeason(offYear) {
    debugger;
    // 获取上一季度
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    year = year + offYear;
    if (month <= 3) {
        year -= 1;
        return `${year}10-${year}12`;
    } else if (month > 3 && month <= 6) {
        return `${year}01-${year}03`;
    } else if (month > 6 && month <= 9) {
        return `${year}04-${year}06`;
    } else if (month > 9 && month <= 12) {
        return `${year}07-${year}09`;
    }
}
function getBeforeYear() {
    // 获取上一年
    const year = new Date().getFullYear() - 1;
    return `${year}-01-01`;
}
function getLevel(iLevel) {
    let waterLevel = "";
    if (iLevel == 1) waterLevel = "Ⅰ";
    if (iLevel == 2) waterLevel = "Ⅱ";
    if (iLevel == 3) waterLevel = "Ⅲ";
    if (iLevel == 4) waterLevel = "Ⅳ";
    if (iLevel == 5) waterLevel = "Ⅴ";
    if (iLevel > 5) waterLevel = "劣Ⅴ";
    return waterLevel;
  }
  function getLevelColor(iLevel) {
    let levelColor = "";
    if (iLevel == 1) levelColor = "#3cc7f5";
    if (iLevel == 2) levelColor = "#11abf1";
    if (iLevel == 3) levelColor = "#5dd420";
    if (iLevel == 4) levelColor = "#ffc000";
    if (iLevel == 5) levelColor = "#fd8200";
    if (iLevel > 5) levelColor = "#fd3c00";
    return levelColor;
  }
export default {
    getLevel: function (iLevel) {
        return getLevel(iLevel);
    },
    getLevelColor: function (iLevel) {
        return getLevelColor(iLevel);
    },
    getSeason: function (offYear) {
        return getSeason(offYear);
    },
    getBeforeYear: function () {
        return getBeforeYear();
    },
    formatDate: function (date, fmt) {
        return formatDate(date, fmt);
    },
    dateDiff: function (interval, date1, date2) {
        return DateDiff(interval, date1, date2);
    },
    getRounding: function (value, num) {
        return getRounding(value, num);
    },
    toFixed: function (value, num) {
        return toFixed(value, num);
    },
    numArrySort: function (arr) {
        return numArrySort(arr);
    },
    getAvgValue: function (arr) {
        return getAvgValue(arr);
    },
    getMedian: function (arr) {
        return getMedian(arr);
    },
    getMedianData: function (arr) {
        return getMedianData(arr);
    },
    downloadFile: function (blobData, blobType, fileName) {
        return DownloadFile(blobData, blobType, fileName);
    }, byteLength: function (str) { return byteLength(str) }
}